<template>
  <div>
    <div v-if="exibirFiltros" aria-label="Tipo de notificação" class="d-flex flex-wrap mb-2" role="group">
      <button v-for="filtro in filtros" :key="filtro.valor" :aria-pressed="tipoSelecionado === filtro.valor"
              :class="tipoSelecionado === filtro.valor ? 'btn-primary' : 'btn-outline-dark'"
              class="btn btn-sm mr-2 mb-2 filtro-notificacao"
              type="button"
              @click="tipoSelecionado = tipoSelecionado === filtro.valor ? '' : filtro.valor">
        {{ filtro.label }}
        <span :class="tipoSelecionado === filtro.valor ? 'badge-light' : 'badge-dark'" class="badge ml-1">
          {{ filtro.quantidade }}
        </span>
      </button>
    </div>
    <notificacao-lista :itens="itens"/>
  </div>
</template>

<script>
import NotificacaoLista from './NotificacaoLista';

export default {
  name: 'Comunicados',
  components: { NotificacaoLista },
  props: {
    aberto: { type: Boolean, default: false },
    informes: { type: Array, default: () => [] }
  },
  data() {
    return { tipoSelecionado: '' };
  },
  computed: {
    exibirFiltros() {
      return this.filtros.every(filtro => filtro.quantidade > 0);
    },
    filtros() {
      return [
        { valor: '2', label: 'Avisos' },
        { valor: '1', label: 'Novidades' }
      ].map(filtro => ({
        ...filtro,
        quantidade: this.informes.filter(informe => informe.tipo === filtro.valor).length
      }));
    },
    itens() {
      return this.informes.filter(informe => ['1', '2'].includes(informe.tipo)
        && (!this.exibirFiltros || !this.tipoSelecionado || informe.tipo === this.tipoSelecionado));
    }
  },
  watch: {
    exibirFiltros(valor) {
      if (!valor) this.tipoSelecionado = '';
    },
    aberto(valor) {
      if (!valor) this.tipoSelecionado = '';
    }
  }
};
</script>

<style scoped>
.filtro-notificacao { min-width: 130px; }
.filtro-notificacao .badge { min-width: 16px; }
</style>
